import * as AssetsPredictPriceActionsType from './actionTypes';
import ReduxActionInterface from '../../model/ReduxActionInterface';
import ReduxRootState from '../../model/Redux/ReduxRootSate';
import IPredictPriceByAssets from '../../model/AssetModel/IPredictPriceByAssets';

const ROOT_VALUE_STATE: ReduxRootState<IPredictPriceByAssets[]> = {
    loading: false,
    error: '',
    data: [{
        assetId: '',
        shares: {
            primaryMarket: 0,
            secondaryMarket: 0,
            primaryMarketPrice: 0,
            secondaryMarketPrice: 0,
            secondaryMarketUnitaryPrice: 0
        }
    }]
};

export const AssetsPredictPriceReducer = (state: ReduxRootState<IPredictPriceByAssets[]> = ROOT_VALUE_STATE, action: ReduxActionInterface) => {
    switch (action.type) {
        case AssetsPredictPriceActionsType.PREDICT_PRICE_LOADING: {
            return {
                ...state,
                loading: true
            };
        }
        case AssetsPredictPriceActionsType.GET_PREDICTED_PRICE_TEAM_GENERATION: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        }
        case AssetsPredictPriceActionsType.PREDICT_PRICE_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            };
        }
        default:
            return state;
    }
};